import { connect } from 'react-redux';
import PerformanceTypeSelectorComponent
  from './../Components/PerformanceTypeSelectorComponent.jsx';
import { getMetricsPageType, getMetricsByDateInfo } from './../reducers';
import {
  setPerformancePageType,
  resetPerformancePage,
  setMetricsByDateInfo
} from './../actions';
import { pageTypes } from './../helpers';


export const mapStateToProps = (state) => {
  return {
    pageType: getMetricsPageType(state),
    metricsDateInfo: getMetricsByDateInfo(state)
  };
};

export const mapDispatchToProps = (dispatch) => ({
  onSubmit: info => {
    dispatch(setPerformancePageType(info));
    if (info.performanceType === pageTypes.EXPORTTESTS.type)
    {
      dispatch(setMetricsByDateInfo(info, '/export-performance'));
    }
    if (info.performanceType === pageTypes.CASEAMENDINGTESTS.type)
    {
      dispatch(setMetricsByDateInfo(info, '/case-amending-performance'));
    }
    if (info.performanceType === pageTypes.CASEAMENDINGKPPTESTS.type)
    {
      dispatch(setMetricsByDateInfo(info, '/case-amending-kpp-performance'));
    }
    if (info.performanceType === pageTypes.JOBBENCHMARK.type) {
      dispatch(setMetricsByDateInfo(info, '/job-benchmark-performance'));
    }
    dispatch(resetPerformancePage());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PerformanceTypeSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/PerformanceTypeSelectorContainer.jsx